<template>
  <div class="sample-manage page-container" v-loading="loading">
    <div class="yn-biz-header">
      <span class="yn-biz-title">样品管理</span>
      <div class="header-actions">
        <el-button size="mini" icon="el-icon-refresh" @click="reloadAll">刷新</el-button>
      </div>
    </div>

    <div class="sm-layout">
      <!-- 左：待分样树 -->
      <div class="sm-left">
        <div class="sm-left-hd">
          <span>待分样 ({{ pendingCount }})</span>
          <el-button type="text" size="mini" @click="loadPending">刷新</el-button>
        </div>
        <el-tree
          ref="tree"
          class="sm-tree"
          :data="treeData"
          node-key="id"
          show-checkbox
          default-expand-all
          :props="{ label: 'label', children: 'children' }"
          @check="onTreeCheck"
        />
        <div v-if="!listLoading && !treeData.length" class="sm-empty">暂无待分样，现场审完后会出现</div>
      </div>

      <!-- 右：操作 + 样品行 -->
      <div class="sm-right">
        <div class="sm-toolbar">
          <el-button
            type="danger"
            size="small"
            plain
            :loading="rolling"
            :disabled="!xmbh || detail.sent || !canRollback"
            @click="onRollback"
          >退回现场监测室数据回退</el-button>
          <el-select
            v-model="receiverYhid"
            size="small"
            filterable
            clearable
            placeholder="选择接收人（按职务）"
            style="width:240px;margin-left:8px"
          >
            <el-option
              v-for="u in receivers"
              :key="u.id"
              :label="u.label || ((u.role_label ? u.role_label + ' · ' : '') + u.xm)"
              :value="String(u.id)"
            />
          </el-select>
          <el-button type="primary" size="small" :loading="sending" :disabled="!xmbh || detail.sent" @click="onSend">
            提交 检测任务安排
          </el-button>
          <span class="sm-meta">
            分样日期
            <el-date-picker v-model="divDate" type="date" value-format="yyyy-MM-dd" size="mini" style="width:140px;margin:0 8px" />
            <span v-if="detail.xmzt_label">状态 {{ detail.xmzt_label }}</span>
            <span class="text-danger" style="margin-left:8px">当前显示 {{ displayRows.length }} 条</span>
          </span>
        </div>

        <el-table :data="displayRows" size="mini" border stripe height="calc(100vh - 220px)">
          <el-table-column type="index" width="44" label="#" />
          <el-table-column prop="ypbh" label="样品编码" min-width="160" />
          <el-table-column prop="fxxm" label="项目" min-width="180" show-overflow-tooltip />
          <el-table-column prop="cdmc" label="点位" width="120" show-overflow-tooltip />
          <el-table-column prop="deliver_xm" label="交样人" width="100" />
          <el-table-column prop="cyrq" label="采样日期" width="110" />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'

export default {
  name: 'SampleManage',
  data() {
    return {
      loading: false,
      listLoading: false,
      sending: false,
      rolling: false,
      pending: [],
      treeData: [],
      checkedSampleKeys: [],
      xmbh: this.$route.query.xmbh || '',
      detail: {},
      divDate: '',
      receiverYhid: '',
      receivers: []
    }
  },
  computed: {
    pendingCount() {
      return (this.pending || []).reduce((n, p) => n + (p.samples || []).length, 0)
    },
    displayRows() {
      const samples = (this.detail && this.detail.samples) || []
      if (!this.checkedSampleKeys.length) return samples
      const set = {}
      this.checkedSampleKeys.forEach(k => { set[k] = 1 })
      return samples.filter(s => set[s.key])
    },
    canRollback() {
      if (!this.xmbh || !this.detail) return false
      if (this.detail.sent) return false
      const zt = String(this.detail.xmzt || '')
      if (['labing', 'lab_done', 'reporting', 'done'].includes(zt)) return false
      return (this.detail.samples || []).length > 0 || zt === 'handover' || this.detail.xmzt_label === '待分样'
    }
  },
  watch: {
    '$route.query.xmbh'(v) {
      if (v && v !== this.xmbh) {
        this.xmbh = v
        this.loadDetail()
      }
    }
  },
  mounted() {
    this.reloadAll()
  },
  methods: {
    normalizeReceivers(list) {
      return (list || []).map(u => {
        const id = String(u.id || u.yhid || '')
        const xm = String(u.xm || '')
        const role = String(u.role_label || '')
        const label = String(u.label || (role ? role + ' · ' + xm : xm))
        return {
          id,
          xm,
          dlh: String(u.dlh || ''),
          jsdm: String(u.jsdm || ''),
          role_label: role,
          label
        }
      }).filter(u => u.id && u.xm)
    },
    applyReceivers(list, preferDefault) {
      const next = this.normalizeReceivers(list)
      if (next.length) this.receivers = next
      if (preferDefault && !this.receiverYhid && this.receivers.length) {
        // 已按 tech_dir → analyst 排序，默认第一位即职务默认人
        this.receiverYhid = this.receivers[0].id
      }
    },
    ensureReceiverInOptions(recv) {
      if (!recv) return
      const id = String(recv.yhid || recv.id || '')
      if (!id) return
      const xm = String(recv.xm || '')
      const role = String(recv.role_label || '')
      const label = role && xm ? role + ' · ' + xm : (xm || id)
      const idx = this.receivers.findIndex(u => String(u.id) === id)
      const row = {
        id,
        xm: xm || id,
        dlh: String(recv.dlh || ''),
        jsdm: String(recv.jsdm || ''),
        role_label: role,
        label
      }
      if (idx < 0) this.receivers = [row, ...this.receivers]
      else this.$set(this.receivers, idx, { ...this.receivers[idx], ...row, xm: xm || this.receivers[idx].xm })
      this.receiverYhid = id
    },
    async reloadAll() {
      await Promise.all([this.loadReceivers(), this.loadPending()])
      if (this.xmbh) await this.loadDetail()
    },
    async loadReceivers() {
      try {
        const res = await api.get('yn_tr_arrange_receivers')
        const items = (res.data && (res.data.items || res.data.receivers)) || []
        this.applyReceivers(items, true)
        if (this.receivers.length) return
      } catch (e) { /* fallback */ }
      try {
        const res = await api.get('yn_tr_div_sample_list')
        this.applyReceivers((res.data && res.data.receivers) || [], true)
      } catch (e) {
        this.receivers = []
      }
    },
    async loadPending() {
      this.listLoading = true
      try {
        const res = await api.get('yn_tr_div_sample_list')
        this.pending = (res.data && res.data.items) || []
        if (res.data && res.data.receivers && res.data.receivers.length) {
          this.applyReceivers(res.data.receivers, !this.receiverYhid)
        }
        this.treeData = this.pending.map(p => ({
          id: 'p-' + p.xmbh,
          label: (p.xmmc || p.xmbh) + (p.sample_count ? ` (${p.sample_count})` : ''),
          xmbh: p.xmbh,
          children: (p.samples || []).map(s => ({
            id: p.xmbh + '::' + s.key,
            label: (s.ypbh || s.key) + (s.cdmc ? ' · ' + s.cdmc : '') + (s.fxxm ? ' · ' + String(s.fxxm).slice(0, 24) : ''),
            xmbh: p.xmbh,
            sampleKey: s.key,
            isLeaf: true
          }))
        }))
        if (this.xmbh) {
          this.$nextTick(() => this.selectProject(this.xmbh, true))
        } else if (this.pending.length === 1) {
          this.xmbh = this.pending[0].xmbh
          this.$nextTick(() => this.selectProject(this.xmbh, true))
          this.loadDetail()
        }
      } catch (e) {
        this.pending = []
        this.treeData = []
      } finally {
        this.listLoading = false
      }
    },
    selectProject(xmbh, checkAll) {
      if (!this.$refs.tree) return
      const keys = []
      this.treeData.forEach(p => {
        if (p.xmbh !== xmbh) return
        ;(p.children || []).forEach(c => keys.push(c.id))
      })
      if (checkAll) this.$refs.tree.setCheckedKeys(keys)
    },
    onTreeCheck() {
      const nodes = this.$refs.tree.getCheckedNodes(true)
      const byProject = {}
      nodes.forEach(n => {
        if (!n.sampleKey || !n.xmbh) return
        if (!byProject[n.xmbh]) byProject[n.xmbh] = []
        byProject[n.xmbh].push(n.sampleKey)
      })
      const xmList = Object.keys(byProject)
      if (!xmList.length) {
        this.checkedSampleKeys = []
        return
      }
      const xmbh = xmList[0]
      if (xmbh !== this.xmbh) {
        this.xmbh = xmbh
        this.loadDetail().then(() => {
          this.checkedSampleKeys = byProject[xmbh] || []
        })
      } else {
        this.checkedSampleKeys = byProject[xmbh] || []
      }
    },
    async loadDetail() {
      if (!this.xmbh) return
      this.loading = true
      try {
        const res = await api.get('yn_tr_div_sample_get', { xmbh: this.xmbh })
        const data = res.data || {}
        if (data.error) {
          this.$message.error(data.error)
          this.detail = {}
          return
        }
        this.detail = data
        if (Array.isArray(data.receivers) && data.receivers.length) {
          this.applyReceivers(data.receivers, !this.receiverYhid)
        }
        this.divDate = data.div_date || this.divDate || new Date().toISOString().slice(0, 10)
        this.checkedSampleKeys = Array.isArray(data.selected_keys) ? data.selected_keys.slice() : []
        if (data.receiver && data.receiver.yhid) {
          this.ensureReceiverInOptions(data.receiver)
        } else if (!this.receiverYhid && this.receivers.length) {
          this.receiverYhid = this.receivers[0].id
        }
        this.$nextTick(() => this.selectProject(this.xmbh, true))
      } catch (e) {
        this.$message.error('加载样品失败')
      } finally {
        this.loading = false
      }
    },
    buildPayload() {
      const recv = this.receivers.find(u => String(u.id) === String(this.receiverYhid))
      return {
        xmbh: this.xmbh,
        div_date: this.divDate || new Date().toISOString().slice(0, 10),
        batch_code: (this.detail && this.detail.batch_code) || '',
        selected_keys: this.checkedSampleKeys.length
          ? this.checkedSampleKeys
          : ((this.detail.samples || []).map(s => s.key)),
        receiver_yhid: this.receiverYhid || '',
        receiver_xm: (recv && recv.xm) || ''
      }
    },
    async onSend() {
      if (!this.xmbh) return
      if (!this.receiverYhid) {
        this.$message.warning('请选择接收人（检测任务安排）')
        return
      }
      const recv = this.receivers.find(u => String(u.id) === String(this.receiverYhid))
      const who = (recv && (recv.label || recv.xm)) || '—'
      try {
        await this.$confirm(
          `确认提交至检测任务安排？接收人：${who}`,
          '提交确认',
          { type: 'warning' }
        )
      } catch (e) {
        return
      }
      this.sending = true
      try {
        const res = await api.postJson('yn_tr_div_sample_send', this.buildPayload())
        const data = res.data || {}
        if (data.error) {
          this.$message.error(data.error)
          return
        }
        this.$message.success('已提交检测任务安排（' + ((data.receiver && data.receiver.xm) || (recv && recv.xm) || '') + '）')
        if (data.detail) this.detail = data.detail
        await this.loadPending()
      } catch (e) {
        this.$message.error('提交失败')
      } finally {
        this.sending = false
      }
    },
    async onRollback() {
      if (!this.xmbh) return
      let reason = ''
      try {
        const { value } = await this.$prompt('必须填写回退原因', '退回现场监测室', {
          confirmButtonText: '确认退回',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputPlaceholder: '请说明退回原因…',
          inputValidator: (v) => {
            if (!v || !String(v).trim()) return '必须填写回退原因'
            return true
          }
        })
        reason = String(value || '').trim()
      } catch (e) {
        return
      }
      this.rolling = true
      try {
        const res = await api.postJson('yn_tr_div_sample_rollback', {
          xmbh: this.xmbh,
          reason
        })
        const data = res.data || {}
        if (data.error) {
          this.$message.error(data.error)
          return
        }
        this.$message.success(data.message || '已退回现场')
        this.xmbh = ''
        this.detail = {}
        this.checkedSampleKeys = []
        await this.loadPending()
      } catch (e) {
        this.$message.error('退回失败')
      } finally {
        this.rolling = false
      }
    }
  }
}
</script>

<style scoped>
.sm-layout {
  display: flex;
  gap: 12px;
  min-height: calc(100vh - 180px);
  background: #fff;
  border: 1px solid #e4e7ed;
}
.sm-left {
  width: 300px;
  border-right: 1px solid #e4e7ed;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.sm-left-hd {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid #e4e7ed;
  font-weight: 600;
}
.sm-tree {
  flex: 1;
  overflow: auto;
  padding: 8px;
}
.sm-empty { color: #909399; font-size: 12px; padding: 12px; text-align: center; }
.sm-right { flex: 1; min-width: 0; display: flex; flex-direction: column; }
.sm-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-bottom: 1px solid #e4e7ed;
  background: #f5f7fa;
}
.sm-meta { font-size: 12px; color: #606266; margin-left: 8px; }
.text-danger { color: #f56c6c; }
</style>
